import { Roles } from '@/core/constants/roleConstants';
import { BasePolicy } from '../BasePolicy';
import { Channels } from '@/core/constants/channelConstants';

export class WeeklyEarningsPolicy extends BasePolicy {
  static canView() {
    const isWholesaler = this.user.VTWEG == Channels.WHOLESALER;
    const roles = [
      Roles.SELLER,
      Roles.MANAGER,
      Roles.SUB_MANAGER,
      Roles.REGIONAL_MANAGER,
      Roles.SUB_DIRECTOR,
      Roles.DIRECTOR,
    ];
    return this.hasAnyRole(roles) && isWholesaler;
  }
}
